import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./styles.css";
import { AuthProvider, useAuth } from "./lib/auth.jsx";
import { ScopeProvider } from "./lib/scope.jsx";
import { ToastProvider, Loading } from "./components/ui.jsx";
import Layout from "./components/Layout.jsx";

import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Devices from "./pages/Devices.jsx";
import DeviceDetail from "./pages/DeviceDetail.jsx";
import Commands from "./pages/Commands.jsx";
import Vending from "./pages/Vending.jsx";
import Usage from "./pages/Usage.jsx";
import Alerts from "./pages/Alerts.jsx";
import Tenants from "./pages/Tenants.jsx";
import Models from "./pages/Models.jsx";
import Production from "./pages/Production.jsx";
import SaaS from "./pages/SaaS.jsx";
import Operators from "./pages/Operators.jsx";

/** Gate renders the console only for a verified session. */
function Gate() {
  const { session, checking } = useAuth();

  if (checking) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Loading label="Restoring your session" />
      </div>
    );
  }
  if (!session) return <Login />;

  return (
    <ScopeProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="devices" element={<Devices />} />
          <Route path="devices/:number" element={<DeviceDetail />} />
          <Route path="commands" element={<Commands />} />
          <Route path="vending" element={<Vending />} />
          <Route path="usage" element={<Usage />} />
          <Route path="alerts" element={<Alerts />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="models" element={<Models />} />
          <Route path="production" element={<Production />} />
          <Route path="saas" element={<SaaS />} />
          <Route path="operators" element={<Operators />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ScopeProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
